export default __webpack_public_path__ + "static/media/large-frame-bg1.37cb94f4.png";